<template>
  <table class="data-table-data-item-style">
    <tr v-for="(fieldData, index) in filteredFields" :key="index" :style="getItemStyle(index)">
      <td class="data-table-label-item-style">{{ fieldData.fieldLabel }}</td>
      <td class="data-table-value-item-style">{{ fieldData.value }}</td>
    </tr>
  </table>

</template>
<script>

import EzUtils from "@/utils/EzUtils";

export default {
  name: "DataTableDataItem",

  data: () => ({
    evenIndexStyle: {background: "#ADD8E6"},
    oddIndexStyle: {background: "#FFFFFF"},
  }),

  props: {
    jsonElement: {
      type: Object,
      required: true,
      default: () => ({})
    },

    dataTableTemplate: {
      type: Object,
      required: true,
      default: () => ({})
    },

    headerFieldDataList: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },

  methods: {
    getItemStyle(index) {
      if (index % 2 === 0) {
        return this.evenIndexStyle;
      } else {
        return this.oddIndexStyle;
      }
    },

    needToShowColumn(columnName) {
      if (!columnName) {
        return false;
      }

      if (EzUtils.isEmpty(this.headerFieldDataList)) {
        return true;
      }

      return this.getStageFieldDataForColumnName(columnName) != null;
    },

    getColumnDisplayText(columnName) {
      const stageFieldData = this.getStageFieldDataForColumnName(columnName);

      return stageFieldData && stageFieldData["fieldLabel"]
          ? stageFieldData["fieldLabel"]
          : EzUtils.removeCharsAndJoinWithUpperCase(columnName, "_", "\\.")
    },

    getStageFieldDataForColumnName(columnName) {
      if (EzUtils.isNotEmpty(this.headerFieldDataList) && columnName) {
        for (let i = 0, n = this.headerFieldDataList.length; i < n; i++) {
          const stageFieldData = this.headerFieldDataList[i];
          if (columnName === stageFieldData["field"]) {
            return stageFieldData;
          }
        }
      }

      return null;
    }
  },

  computed: {
    filteredFields() {
      const filteredFields = [];
      if (EzUtils.isNotEmpty(this.headerFieldDataList)) {
        this.headerFieldDataList.forEach(stageFieldData => {
          const fieldKey = stageFieldData["field"];
          let fieldLabel = stageFieldData["fieldLabel"];
          let fieldValue;
          if (EzUtils.isFieldNested(fieldKey)) {
            fieldValue = EzUtils.getFieldValueForChildObject(fieldKey, this.jsonElement);
          } else {
            const columnHeader =
                EzUtils.getColumnHeaderForColumnName(this.dataTableTemplate, fieldKey);
            fieldValue = EzUtils.getFieldValueForColumnHeader(columnHeader, this.jsonElement);
          }

          if (EzUtils.isEmpty(fieldLabel)) {
            let actualFieldName = fieldKey;
            if (EzUtils.isFieldNested(fieldKey)) {
              actualFieldName = EzUtils.getChildFieldName(fieldKey);
            }
            fieldLabel = EzUtils.removeCharsAndJoinWithUpperCase(actualFieldName, "_", "\\.");
          }

          const fieldData = {fieldLabel: fieldLabel, value: fieldValue};
          filteredFields.push(fieldData);
        });
      } else {
        const columnHeaders = this.dataTableTemplate
            ? this.dataTableTemplate["columnHeaderData"] : [];

        columnHeaders && columnHeaders.forEach(columnHeader => {
          const columnName = EzUtils.getColumnNameWithoutCodeLookup(columnHeader)
          const columnLabel = this.getColumnDisplayText(columnName);
          const columnValue = EzUtils.getFieldValueForColumnHeader(columnHeader, this.jsonElement);
          const fieldData = {fieldLabel: columnLabel, value: columnValue};
          filteredFields.push(fieldData);
        });
      }

      return filteredFields;
    }
  }
}
</script>

<style scoped>
.data-table-data-item-style {
  background: #FFFFFF;
  border-collapse: collapse;
  box-shadow: 4px 3px 7px 0 #bbbbbb;
  width: 100%;
}

.data-table-label-item-style {
  padding: 3px 5px;
  text-align: left;
  font-size: 13px;
  color: gray;
  font-weight: bolder;
}

.data-table-value-item-style {
  padding: 3px 5px;
  text-align: center;
  font-size: 13px;
  color: black;
  font-weight: bolder;
  word-break: break-word;
}

</style>

<style
    scoped
    src="../../assets/style/base.css"></style>